import { render } from "./DashMatePrivacyPolicy.vue?vue&type=template&id=4493cb36&scoped=true"
const script = {}

import "./DashMatePrivacyPolicy.vue?vue&type=style&index=0&id=4493cb36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4493cb36"]])

export default __exports__